import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import {
  useDeleteUsedEquipmentMutation,
  useFetchUsedEquipmentsQuery,
} from "../../../store";
import Loading from "../../../components/shared/Loading";
import { columns } from "./utils/columns";
import TextField from "@mui/material/TextField";
import { useDispatch, useSelector } from "react-redux";
import { setUsedEquipment } from "../../../store/slices/applicationManagement/managementSlice";
import {
  closeDialog,
  openDialog,
} from "../../../store/slices/dialog/dialogSlice";
import {
  CONFIRM_DIALOG,
  GIVE_BACK_EQUIPMENT_DIALOG,
} from "../../../store/slices/utils/dialogEnum";
import CustomConfirmDialog from "../../../components/shared/CustomConfirmDialog";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../store/slices/toast/toastSlice";
import GiveBackModal from "./components/GiveBackModal";

const UsedEquipments = () => {
  const dispatch = useDispatch();
  const { usedEquipment } = useSelector((state) => state.managementSlice);
  const { giveBackEquipmentDialogOpen } = useSelector(
    (state) => state.dialogSlice
  );
  const [searchText, setSearchText] = React.useState("");
  const normalizeTurkish = (text) => {
    // Latin 'i' → Türkçe 'ı' (noktalı olmayan), Latin 'I' → Türkçe 'İ'
    return text
      .replace(/i/g, "ı")
      .replace(/I/g, "İ");
  };
  const [pagination, setPagination] = React.useState({
    pageSize: 20,
    page: 0,
  });

  // Arama metni değişince her zaman 1. sayfaya dön
  React.useEffect(() => {
    setPagination((prev) => ({ ...prev, page: 0 }));
  }, [searchText]);

  const { data, isLoading } = useFetchUsedEquipmentsQuery({
    page: pagination.page === 0 ? 1 : pagination.page + 1,
    limit: pagination.pageSize,
    searchText: normalizeTurkish(searchText),
  });
  const [deleteUsedEquipment, { isLoading: deleteUsedEquipmentLoading }] =
    useDeleteUsedEquipmentMutation();

  const handleGiveBack = (usedEquipment) => {
    dispatch(setUsedEquipment(usedEquipment));
    dispatch(openDialog(GIVE_BACK_EQUIPMENT_DIALOG));
  };

  const handleDelete = (usedEquipment) => {
    dispatch(setUsedEquipment(usedEquipment));
    dispatch(openDialog(CONFIRM_DIALOG));
  };
  const closeDelete = () => {
    dispatch(setUsedEquipment(null));
    dispatch(closeDialog(CONFIRM_DIALOG));
  };
  const postDelete = () => {
    deleteUsedEquipment(usedEquipment.id).then((res) => {
      if (res) {
        if (!res.data.isSuccess) {
          dispatch(openErrorToast(res.data.message));
        } else {
          dispatch(openSuccessToast("İşlem Tamamlandı"));
          closeDelete();
        }
      }
    });
  };

  const rowCountRef = React.useRef(data?.data.totalRowCount || 0);
  const rowCount = React.useMemo(() => {
    if (data?.data.totalRowCount !== undefined) {
      rowCountRef.current = data?.data.totalRowCount;
    }
    return rowCountRef.current;
  }, [data?.data.totalRowCount]);

  if (isLoading) return <Loading isLoading={isLoading} />;
  return (
    <Box
      sx={{
        height: 500,
        width: "100%",
        marginTop: 10,
        minWidth: { xs: 600, sm: 0 },
        flex: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 2,
          width: "100%",
        }}
      >
        <TextField
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          placeholder="Marka, Model, Seri No veya Servis Etiketine Göre Ara..."
          size="small"
          sx={{ width: 400 }}
        />
      </Box>
      {
        <CustomConfirmDialog
          handleConfirm={postDelete}
          title="Kullanılan Ekipman Kaldır"
          text="Bu Ekipmanı Kullanılanlardan kaldırmak istediğinize emin misiniz ? Ekipman Kullanılabilir Ekipmanlar listesine taşınacaktır."
          isLoading={deleteUsedEquipmentLoading}
          handleClose={closeDelete}
        />
      }
      {giveBackEquipmentDialogOpen && <GiveBackModal />}
      <DataGrid
        rows={data?.data.usedEquipments || []}
        rowCount={rowCount}
        loading={isLoading}
        disableColumnMenu
        columns={columns(handleDelete, handleGiveBack)}
        paginationMode="server"
        pageSizeOptions={[5, 10, 25, 50]}
        disableRowSelectionOnClick
        paginationModel={pagination}
        onPaginationModelChange={setPagination}
        getRowHeight={() => "auto"}
      />
    </Box>
  );
};

export default UsedEquipments;
